import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const gb = b => b >= 1e9 ? (b / 1e9).toFixed(2) + ' ГБ' : Math.round(b / 1e6) + ' МБ';
const when = d => new Date(d).toLocaleString('ru-RU', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export default function BackupPage() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const load = () => api.get('/backup').then(r => setData(r.data)).catch(() => setErr('Не удалось получить список архивов'));
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!data || !data.running) return;
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [data]);

  const run = () => {
    if (!window.confirm('Сделать полный бэкап сервера сейчас? Это займёт около 5 минут, CRM продолжит работать.')) return;
    api.post('/backup/run').then(load).catch(e => alert(e.response?.data?.error || 'Не удалось запустить'));
  };

  return (
    <div>
      <div className="page-header"><h1 className="page-title">Бэкап сервера</h1></div>

      <div className="card" style={{ marginBottom: 16, fontSize: 14, lineHeight: 1.55 }}>
        <p style={{ marginTop: 0 }}>В архиве <b>весь сервер</b>: базы данных (CRM, МФЦ, ДЗ), файлы клиентов и дел, правовая база, сайт ucfemida.ru и его исходники, CRM, сервисы МФЦ и ДЗ, сторож сделок, настройки сервера и сертификаты, ключи.</p>
        <p>Автоматически делается <b>каждое воскресенье в 03:37</b>, хранятся последние 4 архива. Скачивайте свежий хотя бы раз в месяц и держите на компьютере или флешке.</p>
        <p style={{ marginBottom: 0, color: '#b45309' }}>⚠ В архиве персональные данные клиентов и ключи доступа. Не пересылайте его и не храните в открытом облаке.</p>
      </div>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
          <div className="section-title" style={{ margin: 0 }}>Архивы</div>
          <button className="btn btn-primary" disabled={!data || data.running} onClick={run}>
            {data && data.running ? '⏳ Делается бэкап…' : 'Сделать бэкап сейчас'}
          </button>
        </div>
        {err && <div style={{ color: 'var(--red)' }}>{err}</div>}
        {data && data.running && <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 8 }}>Архив собирается (около 5 минут). Страница обновится сама.</div>}
        {data && data.files.map((f, i) => (
          <div key={f.name} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderTop: '1px solid var(--border)', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontWeight: 600 }}>{when(f.date)}{i === 0 && <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--green)' }}>последний</span>}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{gb(f.size)}</div>
            </div>
            <a className={`btn ${i === 0 ? 'btn-primary' : 'btn-secondary'} btn-sm`} href={`/api/backup/download/${f.name}`}>Скачать</a>
          </div>
        ))}
        {data && !data.files.length && <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Архивов пока нет — нажмите «Сделать бэкап сейчас».</div>}
      </div>

      <div className="card" style={{ marginTop: 16, fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.55 }}>
        <b>Если сервер сломается:</b> арендуете новый сервер (Ubuntu), загружаете на него архив и пишете Claude «восстанови сервер из бэкапа» — восстановление делает скрипт из архива (<code>restore_server.sh</code>). Потом нужно будет перенастроить домены в DNS на новый адрес.
      </div>
    </div>
  );
}
